import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { InventoryOverride } from '@/lib/inventoryOverrides';

const QUERY_KEY = ['inventory_overrides'];

export const useInventoryOverrides = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async (): Promise<Map<string, InventoryOverride>> => {
      const { data, error } = await supabase
        .from('inventory_overrides_public')
        .select('*');

      if (error) {
        console.error('Failed to fetch inventory overrides:', error);
        throw error;
      }

      const map = new Map<string, InventoryOverride>();
      data?.forEach((row) => {
        map.set(row.product_handle, row as InventoryOverride);
      });
      return map;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};

export const useInventoryOverride = (handle?: string) => {
  const { data: overrides, isLoading, error } = useInventoryOverrides();
  return {
    override: handle ? overrides?.get(handle) : undefined,
    isLoading,
    error,
  };
};
